// extracted by mini-css-extract-plugin
module.exports = {"expandedIcon":"ExpandedIcon_expandedIcon__uyeqt"};